/*
@license
  Expanse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/expanse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

if (console && console.log) {
  console.log(
    "Expanse theme (" +
      theme.settings.themeVersion +
      ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
  );
}

(function () {
  "use strict";

  if (
    window.Shopify &&
    window.Shopify.theme &&
    navigator &&
    navigator.sendBeacon &&
    window.Shopify.designMode
  ) {
    navigator.sendBeacon(
      "https://api.archetypethemes.co/api/beacon",
      new URLSearchParams({
        shop: window.Shopify.shop,
        themeName:
          window.theme &&
          window.theme.settings &&
          `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
        role: window.Shopify.theme.role,
        route: window.location.pathname,
        themeId: window.Shopify.theme.id,
        themeStoreId: window.Shopify.theme.theme_store_id || 0,
        isThemeEditor: !!window.Shopify.designMode,
      })
    );
  }

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  DOMready(function () {
    document.dispatchEvent(new CustomEvent("page:loaded"));
  });
})();


 /*============================================================================
    Aggiungi al carrello senza redirect
  ==============================================================================*/

document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll('form[action^="/cart/add"]').forEach(form => {
    form.addEventListener("submit", function(e) {
      e.preventDefault();
      let formData = new FormData(this);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        console.log("Prodotto aggiunto:", data);
        updateCartCount(); // Aggiorna l'icona del carrello
        showCartNotification();
      })
      .catch(error => console.error("Errore:", error));
    });
  });
});

// Aggiorna il numero di articoli nel carrello
function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      let cartCount = cart.item_count;
      let cartIcon = document.querySelector('.cart-link__bubble-num'); // Cambiato il selettore

      if (cartIcon) {
        cartIcon.textContent = cartCount;
        if (cartCount > 0) {
          cartIcon.parentElement.classList.add("cart-link__bubble--visible");
        } else {
          cartIcon.parentElement.classList.remove("cart-link__bubble--visible");
        }
      }
    })
    .catch(error => console.error("Errore nell'aggiornamento del carrello:", error));
}


function showCartNotification() {
  let notification = document.createElement("div");
  notification.innerHTML = `
    <div style="
      position: fixed;
      top: 20px;
      right: 20px;
      background: #fff;
      color: #333;
      padding: 15px;
      border-radius: 5px;
      box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
      z-index: 1000;
      display: flex;
      align-items: center;
      gap: 10px;
    ">
      <span>🛒 Prodotto aggiunto al carrello!</span>
      <a href="/cart" style="
        background: #6ad7ce;
        color: white;
        padding: 5px 10px;
        border-radius: 3px;
        text-decoration: none;
        font-weight: bold;
      ">Vai al Carrello</a>
    </div>
  `;

  document.body.appendChild(notification);
  setTimeout(() => notification.remove(), 3000); // Rimuove il messaggio dopo 3 secondi
}


document.addEventListener('DOMContentLoaded', function() {
  const link = document.querySelector('a[href="#shopify-section-template--23273126101328__rich_text_adPnK7"]');

  if(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      const target = document.querySelector('#shopify-section-template--23273126101328__rich_text_adPnK7');
      
      if(target) {
        smoothScroll(target, 1200); // durata in millisecondi (800 ms = 0.8 sec)
      }
    });
  }

  function smoothScroll(target, duration) {
    let targetPosition = target.getBoundingClientRect().top + window.scrollY;
    let startPosition = window.scrollY;
    let distance = targetPosition - startPosition;
    let startTime = null;

    function animation(currentTime) {
      if (startTime === null) startTime = currentTime;
      let timeElapsed = currentTime - startTime;
      let run = easeInOutQuad(timeElapsed, startPosition, distance, duration);
      window.scrollTo(0, run);
      if (timeElapsed < duration) requestAnimationFrame(animation);
    }

    function easeInOutQuad(t, b, c, d) {
      t /= d/2;
      if (t < 1) return c/2*t*t + b;
      t--;
      return -c/2 * (t*(t-2) - 1) + b;
    }

    requestAnimationFrame(animation);
  }
});
